export default "__VITE_ASSET__BOJFfrkO__"